module.exports = __webpack_public_path__ + "img/cup.ee3c8c35.png";